





































import { Component, Prop, Ref, Mixins } from "vue-property-decorator";
import CompanyFamiliesMixin from "@/mixins/http/CompanyFamiliesMixin";
import CatalogueListItem from "./CatalogueListItem.vue";
import EditCompanyFamilyModal from "@/components/CompanyFamily/Edit.vue";
import { currentUserStore } from "@/store/typed";
import { CompanyFamily } from "../../models";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";

@Component({ components: { CatalogueListItem, EditCompanyFamilyModal } })
export default class CatalogueList extends Mixins(CompanyFamiliesMixin) {
  private families: CompanyFamily[] = [];
  static getFamiliesTag = "company_get_families_tag";

  @Ref() readonly editModal!: EditCompanyFamilyModal;

  @Prop({ required: true }) readonly companyId!: string;

  @RegisterHttp(CatalogueList.getFamiliesTag)
  private getFamiliesRequest: RequestData;

  async created() {
    this.families = await this.getCompanyFamilies(
      this.payload,
      CatalogueList.getFamiliesTag
    );
  }

  get payload() {
    return {
      filter: {
        company: this.companyId,
      },
    };
  }

  onCreated(item: CompanyFamily) {
    this.families.unshift(item);
  }

  onUpdated(item: CompanyFamily) {
    const index = this.families.findIndex((o) => item.id === o.id);
    this.$set(this.families, index, item);
  }

  get hasItems(): boolean {
    return this.families.length > 0;
  }

  openCreateModal() {
    this.editModal.create(this.companyId);
  }

  openEditModal(item: CompanyFamily) {
    this.editModal.edit(item);
  }
}
